<template>
  <!-- メインコンテンツ: 上段共通エリア -->
  <div class="l-main-head">
    <div class="c-title u-w600">
      <div class="c-title__text c-title__text--blue u-fs34">{{ title }}</div>
      <div v-if="text != null" class="c-title__text">{{ text }}</div>
    </div>
    <a v-if="(linkUrl != null) && (linkText != null)" class="c-btn c-btn--gray u-w250" :href="linkUrl">
      <p class="c-btn__text">{{ linkText }}</p>
    </a>
  </div>
<!-- /メインコンテンツ: 上段共通エリア -->

</template>

<script>
export default {
  props: {
    title: String,
    text: String,
    linkUrl: String,
    linkText: String,
  },
}
</script>
